import React from "react";
import { process } from "../mock";
import SectionHeading from "./SectionHeading";
import TechBackdrop from "./TechBackdrop";

export default function ProcessSteps() {
  return (
    <section className="relative py-20 lg:py-28 bg-gradient-to-b from-slate-50 to-white overflow-hidden">
      <TechBackdrop variant="topology" opacity={0.07} />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Our approach"
          title="Four phases. No surprises."
          description="Every engagement follows the same repeatable rhythm. We lean heavily on planning so that execution is a non-event."
        />

        <div className="mt-16 relative">
          {/* Animated connector line (desktop only) */}
          <svg
            className="hidden lg:block absolute left-0 right-0 top-[40px] h-2 w-full pointer-events-none"
            viewBox="0 0 1000 4"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <line x1="40" y1="2" x2="960" y2="2" stroke="hsl(var(--brand-200))" strokeWidth="1" />
            <line
              x1="40" y1="2" x2="960" y2="2"
              stroke="hsl(var(--brand-700))"
              strokeWidth="1.5"
              strokeDasharray="8 8"
              className="animate-dash-flow"
            />
            {/* travelling pulse */}
            <circle r="4" fill="hsl(var(--brand-500))">
              <animateMotion
                dur="6s"
                repeatCount="indefinite"
                path="M 40 2 L 960 2"
              />
              <animate
                attributeName="opacity"
                values="0;1;1;0"
                keyTimes="0;0.1;0.9;1"
                dur="6s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
            {process.map((p, i) => (
              <div
                key={i}
                className="relative rounded-2xl bg-white border border-slate-200 p-6 hover-lift"
              >
                <div className="flex items-center gap-3">
                  <div className="relative h-11 w-11 rounded-full bg-brand-700 text-white grid place-items-center font-display font-bold shadow-lg shadow-brand-900/15">
                    {i + 1}
                    <span className="absolute inset-0 rounded-full border-2 border-brand-400 animate-pulse-ring" />
                  </div>
                  <div className="font-mono text-[11px] tracking-[0.2em] text-brand-700">
                    {p.step}
                  </div>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold text-slate-900">
                  {p.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-slate-600">
                  {p.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
